import { ACC_JOU_CHART_ITEM } from './acc-jou-chart.js'
import { ACC_JOU_GENERATE_ITEM } from './acc-jou-generate.js'
import { ACC_JOU_MANUAL_ITEM } from './acc-jou-manual.js'

/** @type {import('../help-index.js').HelpScreen} */
export const ACC_JOU_HELP = {
  screenId: 'acc-jou',
  label: 'Asientos',
  navPath: 'Contabilidad → Asientos',
  keywords: [
    'asiento contable', 'diario', 'generar asientos', 'plan de cuentas', 'debe', 'haber', 'manual',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Plan de cuentas, generación automática desde operaciones y asientos manuales balanceados.',
  sidebarItems: [
    ACC_JOU_CHART_ITEM,
    ACC_JOU_GENERATE_ITEM,
    ACC_JOU_MANUAL_ITEM,
  ],
}
